import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=990ebd90"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=990ebd90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports